import {batch, computed, signal, useSignal} from "@preact/signals-react";
import {NOTIFICATIONS_TYPE} from "../@constants";

export const repricingAlerts = signal([])
export const repricingSearchText = signal('')
export const repricingNotificationsType = signal(NOTIFICATIONS_TYPE.REPRICING)
export const repricingIsLoadingNotifications = signal(true)
export const repricingAlertsClicked = signal([])

// Computed
export const repricingAlertsFiltered = computed(() => {
	if (!repricingSearchText.value) return repricingAlerts.value
	return repricingAlerts.value.filter(item  => {
		const alertName = (item.name || '').toLowerCase()
		const qs = (repricingSearchText.value || '').toLowerCase()
		return alertName.includes(qs)
	})
})

// functions
export const clearRepricingHomeSignals = () => batch(() => {
	repricingAlerts.value = []
	repricingSearchText.value = ''
	repricingNotificationsType.value = NOTIFICATIONS_TYPE.REPRICING
	repricingIsLoadingNotifications.value = true
})